import React from 'react';
import '../../App.css';


export default function Products() {
         return <h1 class="products">PRODUCTS</h1>;
}